import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import Spinner from "../common/Spinner";
import Footer from "../footer/Footer";
import styles from "./authLayout.module.css";

// Auth layout: no site navbar (the auth pages carry their own brand + escape),
// but the site footer is kept for social links + company information. The main
// area fills the space between the top and the footer so content never hugs the
// viewport edges.
const AuthLayout = () => (
  <div className={styles.shell}>
    <main className={styles.main}>
      <Suspense
        fallback={
          <div className={styles.fallback} role="status" aria-live="polite">
            <Spinner label="Loading…" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </main>
    <Footer />
  </div>
);

export default AuthLayout;
